// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FormSelect__formSelect___aG1Zl {
    -moz-appearance: none;
    -webkit-appearance: none;
}

.FormSelect__formSelect___aG1Zl:focus {
    box-shadow: gold 0px 0px 7px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formSelect": `FormSelect__formSelect___aG1Zl`
};
module.exports = ___CSS_LOADER_EXPORT___;
